<template>
  <v-row justify="center">
    <v-stepper
      v-model="step"
      style="background: transparent;"
      class="auth-container"
    >
      <v-stepper-header>
        <v-row class="ma-2"><slot name="logo"></slot></v-row>
      </v-stepper-header>
      <v-card class="elevation-12" tile>
        <v-form
          v-model="formValid"
          lazy-validation
          @submit.prevent="submit"
          :disabled="loading"
        >
          <v-card-title><h2>Forgotten password</h2></v-card-title>
          <v-card-text>
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0">
                <v-text-field
                  filled
                  v-model="email"
                  name="email"
                  type="email"
                  label="Email address"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0">
                <v-col align="center">
                  <p>
                    <v-img
                      :src="require('@/assets/images/ic-email-sent@3x.png')"
                      width="63"
                      height="63"
                    ></v-img>
                  </p>
                  <p class="text-section-title">Check your inbox</p>
                  <p>
                    If we recognise your account, we have send an email that
                    contains a link to enter your new password.
                  </p>
                </v-col>
              </v-stepper-content>
            </v-stepper-items>
          </v-card-text>
          <v-card-actions>
            <v-btn text class="button color--inactive" :to="{ name: 'login' }"
              >Cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              v-if="step === 1"
              class="button"
              color="primary"
              :disabled="!formValid"
              :loading="loading"
              @click.prevent="submit"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-stepper>
  </v-row>
</template>

<script>
import { textFieldRules } from '@/common'
import { mapActions } from 'vuex'
import { auth } from '@/firebaseConfig'
export default {
  data: () => ({
    step: 1,
    formValid: false,
    loading: false,
    email: '',
    rules: textFieldRules,
    emailSent: false
  }),
  methods: {
    ...mapActions(['showError']),
    async submit() {
      this.loading = true
      try {
        await auth.sendPasswordResetEmail(this.email)
        this.step = 2
      } catch (error) {
        console.error(error)
        this.showError(error.message ?? 'Failed, please try again later')
      }
    }
  }
}
</script>
